<template>
  <section class="section">
    <div class="sectionCnt">
      <div class="formHeader">
        <div class="nunuLili">
          <img src="../assets/logo.png">
        </div>
        <h4>CHALLENGE YOUR LIMIT
          <br />with BODYKEY BY NUTRILITE</h4>
        <p>Psst, ada yang baru, lho, di BodyKey Challenge #6 kali ini.
          makin seru, menantang, dan fun! siapin diri kamu jadi finisher!</p>
      </div>
      <div v-if="!regOpen">
        <div class="cdLabel">Pendaftaran dibuka dalam</div>
        <div class="cdCnt">
          <span>{{cd.h}}</span>:<span>{{cd.m}}</span>:<span>{{cd.s}}</span>
        </div>
      </div>
      <div v-else>
        <div class="formInfo" v-if="st === 'reg'">Masuk dengan akun kamu</div>
        <form v-on:submit.prevent="login">
          <div class="welcomeCnt">
            <div class="welcome" v-if="st === 'reg2'">
              Selamat datang
              <h4>{{name}}</h4>
              <div class="close" v-on:click="st = 'reg'">Change user</div>
            </div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.username.error}" v-if="st === 'reg'">
            <input type="text" class="field" placeholder="Email / No. Telp."
              ref="username"
              v-model="form.username.model" v-on:input="fieldChanged('username')">
            <div class="fieldError" v-if="form.username.error">{{form.username.error}}</div>
          </div>
          <div :class="{fieldGroup: true, fg2: true, hasError: form.password.error}" v-else>
            <div class="fieldCnt">
              <input :type="form.password.type" class="field" placeholder="Password kamu"
                ref="password"
                v-model="form.password.model" v-on:input="fieldChanged('password')">
              <div :class="{showPwd: true, show: form.password.type === 'text'}"
                v-on:click="form.password.type = (form.password.type === 'text')
                ? 'password' : 'text'"></div>
            </div>
            <div class="fieldError" v-if="form.password.error">{{form.password.error}}</div>
          </div>
          <div class="forgotEmail" v-if="st === 'reg'"
            v-on:click="forgotEmail">Lupa Email atau No. Telp.?</div>
          <div class="forgotPwd" v-if="st === 'reg2'"
            v-on:click="forgotPwd">Lupa password?</div>
          <button class="btn primary block"
            :class="{btnLoading: formLoading}">
            <span v-if="st === 'reg'">Berikutnya</span>
            <span v-else>Masuk</span>
          </button>
          <div class="loginLinkCnt" v-if="st === 'reg'">
            <router-link to="/" class="loginLink">
              Kamu belum punya akun? <b>Daftar disini</b></router-link>
          </div>
        </form>
      </div>
    </div>
    <EmailSent ref="emailSent"/>
    <ForgotPwd ref="forgotPwd"/>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import EmailSent from '@/components/EmailSent.vue';
import ForgotPwd from '@/components/ForgotPwd.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { EmailSent, ForgotPwd, Confirmation },
  data() {
    return {
      st: 'reg',
      formLoading: false,
      name: null,
      regOpen: false,
      form: {
        username: { model: '', error: null },
        password: { model: '', error: null, type: 'password' },
      },
      ts: new Date('26 May 2023 00:00:00 +7'),
      cd: { h: '--', m: '--', s: '--' },
      cdInterval: null,
    };
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
    fieldChanged(field) {
      this.form[field].error = false;
    },
    forgotEmail() {
      this.$refs.confirmDialog.open({
        title: 'Hubungi Admin',
        desc: `Silahkan hubungi Customer Service Amway untuk
          mendapatkan kredensial login kamu`,
        confirm: false,
        action: 'Tutup',
      });
    },
    forgotPwd() {
      this.$refs.confirmDialog.open({
        title: 'Hubungi Admin',
        desc: `Silahkan hubungi Customer Service Amway untuk
          reset password kamu`,
        confirm: false,
        action: 'Tutup',
      });
      // this.$refs.forgotPwd.open({ email: this.name }, (b) => {
      //   if (b) this.$refs.emailSent.open();
      // });
    },
    login() {
      if (this.formLoading) return;
      if (this.st === 'reg') {
        // Check is user not empty
        if (!this.form.username.model || this.form.username.model === '') {
          this.form.username.error = 'Mohon masukan Email / No. Telp. kamu.';
          return;
        }

        // POE
        this.formLoading = true;
        const session = this.$route.query.session || '';
        this.$http.post(this.$config.uri(`user/verify/poe?session=${session}`), {
          user: this.form.username.model,
        }).then((r) => {
          this.formLoading = false;
          if (r.data.status !== 200) {
            this.form.username.error = 'Email / No. Telp. tidak ditemukan';
            return;
          }
          this.name = r.data.name;
          this.st = 'reg2';
          setTimeout(() => {
            this.$refs.password.focus();
          });
        });
        return;
      }
      const formData = {
        user: this.form.username.model,
        password: this.form.password.model,
      };
      if (!formData.user || formData.user === '') {
        this.form.username.error = 'Mohon masukan Email / No. Telp. kamu.';
        return;
      }
      if (!formData.password || formData.password === '') {
        this.form.password.error = 'Mohon masukan Password kamu.';
        return;
      }
      this.formLoading = true;
      const session = this.$route.query.session || '';
      this.$http.post(this.$config.uri(`user/signin?session=${session}`), formData).then((r) => {
        this.formLoading = false;
        if (r.data.status !== 200) {
          this.form.password.error = 'Password yang kamu masukan salah';
          return;
        }
        this.formLoading = false;
        this.$session.set('bk6_id', r.data.user.id);
        this.$session.set('bk6_role', r.data.user.role);
        this.$session.set('bk6_name', r.data.user.name);
        this.$session.set('bk6_email', r.data.user.email);
        this.$session.set('bk6_avatar', r.data.user.avatar);
        this.$session.set('bk6_birthdate', r.data.user.birthdate);
        this.$session.set('bk6_finisherBk2', r.data.user.finisherBk2);

        this.$session.set('bk6_point', r.data.user.point);
        this.$session.set('bk6_character', r.data.user.character);

        this.$session.set('bk6_accTop', r.data.user.accTop);
        this.$session.set('bk6_accMid', r.data.user.accMid);
        this.$session.set('bk6_accBot', r.data.user.accBot);
        this.$session.set('bk6_bg', r.data.user.bg);
        this.$session.set('bk6_customBg', r.data.user.customBg);
        this.$session.set('bk6_finisher', r.data.user.finisher);

        this.$session.set('bk6_gender', r.data.user.gender);

        this.$session.set('bk6_bodyHeight', r.data.user.bodyHeight);
        this.$session.set('bk6_bodyWeight', r.data.user.bodyWeight);
        this.$session.set('bk6_waistSize', r.data.user.waistSize);

        this.$session.set('bk6_bmi', r.data.user.bmi);
        this.$session.set('bk6_bmiType', r.data.user.bmiType);
        this.$session.set('bk6_bmr', r.data.user.bmr);
        this.$session.set('bk6_tdee', r.data.user.tdee);
        this.$session.set('bk6_tdeeType', r.data.user.tdeeType);

        this.$session.set('bk6_tshirt_size', r.data.user.tshirtSize);

        this.$session.set('bk6_jwt', r.data.token);

        if (!r.data.user.avatar || r.data.user.avatar === '') {
          window.location.href = `${this.$config.appPath}user/avatar`;
        } else if (!r.data.user.character || r.data.user.character === '') {
          window.location.href = `${this.$config.appPath}character/choose`;
        } else if (!r.data.user.bmi || r.data.user.bmi === '') {
          window.location.href = `${this.$config.appPath}body-composition`;
        } else {
          window.location.href = `${this.$config.appPath}main`;
        }
      });
    },
    checkMint() {
      const d = new Date();
      this.regOpen = (d.getTime() >= this.ts.getTime());
      const dst = this.ts.getTime() - d.getTime();
      const h2 = Math.floor((dst % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cd.h = (h2 < 10) ? `0${h2.toString()}` : h2.toString();
      this.cd.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cd.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      if (dst <= 0) {
        this.regOpen = true;
        clearInterval(this.cdInterval);
        setTimeout(() => {
          this.$refs.username.focus();
        });
      }
    },
  },
  mounted() {
    // Check login
    if (this.$session.get('bk6_email')) {
      if (!this.$session.get('bk6_character') || this.$session.get('bk6_character') === '') {
        this.$router.push('/character/choose');
      } else if (!this.$session.get('bk6_bmi') || this.$session.get('bk6_bmi') === '') {
        this.$router.push('/body-composition');
      } else {
        this.$router.push('/main');
      }
      return;
    }

    const d = new Date();
    if (d.getTime() < this.ts.getTime()) {
      this.checkMint();
      this.cdInterval = setInterval(() => {
        this.checkMint();
      }, 1000);
    } else {
      this.regOpen = true;
      setTimeout(() => {
        this.$refs.username.focus();
      });
    }

    // setTimeout(() => {
    //   this.$refs.username.focus();
    // });
  },
};
</script>

<style scoped lang="scss">
.section{
  padding: 0 20px 40px;
  box-sizing: border-box;
  @media (min-height: 600px) {
    height: 100vh;
    display: flex;
    align-items: center;
  }
  @media (max-width: 768px) {
    height: calc(100vh - 60px);
  }
}
.cdLabel{
  padding: 30px 0 20px;
  text-align: center;
  font-weight: 600;
}
.cdCnt{
  display: flex;
  justify-content: center;
  font-size: 46px;
  span{
    display: block;
    background-color: #c6e3ce;
    color: #28b998;
    padding: 10px 10px;
    border-radius: 10px;
    margin: -6px 10px 0;
    font-weight: 600;
  }
}
.formHeader{
  text-align: center;
  .nunuLili{
    text-align: center;
    margin: 0 -60px 20px;
    @media (max-width: 680px) {
      margin: 0 0 20px;
    }
    img{
      width: 100%;
      max-width: 600px;
    }
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 22px;
    margin: 0 0 6px;
    display: none;
  }
  p{
    margin: 0 0 10px;
    font-size: 15px;
  }
}
.clhCnt{
  background-color: rgba(255,255,255,.6);
  border-radius: 7px;
  padding: 10px 0;
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    padding: 6px 20px;
    list-style: none;
    padding-left: 58px;
    position: relative;
    font-weight: bold;
    font-size: 14px;
    &:before{
      content: "";
      position: absolute;
      left: 24px; top: 5px; bottom: 0;
      width: 20px;
      background-image: url(../assets/checked-green.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
.welcomeCnt{
  // text-align: center;
  .welcome{
    background-color: #e9ffcc;
    // display: inline-block;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 14px;
    text-align: left;
    margin: 20px 0 12px;
    border: #78c90e 1px solid;
    position: relative;
    color: #767676;
    h4{
      margin: 0px 0 0;
      font-size: 17px;
      color: #417201;
    }
    .close{
      position: absolute;
      right: 10px; top: 50%;
      background-color: #78C90E;
      border-radius: 50px;
      padding: 5px 12px;
      color: #fff;
      font-weight: 600;
      margin-top: -14px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #5ba100;
      }
    }
  }
}
.fieldGroup{
  margin-bottom: 4px;
}
.forgotPwd, .forgotEmail{
  font-weight: 600;
  color: #78C90E;
  padding: 5px 10px;
  display: inline-block;
  margin: 0 0 14px;
  transition: all .3s ease;
  cursor: pointer;
  &:hover{
    color: #5ba100;
  }
}
.formInfo{
  margin: 34px 10px 10px;
  font-weight: 600;
  font-size: 14px;
  color: #555;
  &.syaratnya{
    margin: 16px 10px 10px;
  }
  // text-transform: uppercase;
}
.loginLinkCnt{
  text-align: center;
}
.loginLink{
  font-size: 15px;
  padding: 6px 10px;
  display: inline-block;
  margin: 12px auto 0;
}
</style>
